/* cg-gift.js — de wagen-engine van het cadeau-systeem van Brand OS (koop X,
   krijg Y gratis), zonder afhankelijkheden.

   WAT HET DOET
   Bij het laden van de pagina en bij elke wagenwijziging kijkt de engine of de
   wagen aan een aanbod voldoet, voegt het cadeau toe met een privé-eigenschap
   (_cg_gift = het aanbod-id), en haalt alleen dat eigen cadeau weer weg als de
   wagen niet meer voldoet. De korting zelf is Shopify's eigen Buy X Get Y-
   korting: dit script zet nooit een prijs op nul, het zet alleen de regel klaar.

   WAT HET NOOIT DOET
   - een regel zonder onze eigen eigenschap aanraken: een Pro Gel die de klant
     zelf toevoegde blijft staan, ook als het aanbod verloopt;
   - de checkout blokkeren: elke fout (422, netwerk) is een console.warn en door;
   - twee keer tegelijk draaien, of zichzelf triggeren met zijn eigen aanroepen.

   TESTBAAR
   De rekenlogica (bereken) is puur: een wagen in de vorm van de Ajax Cart API
   erin, een lijst mutaties eruit, zonder DOM of fetch. Node laadt hem via
   module.exports (tools/test-gift-engine.js); de browser draait de IIFE. */
(function () {
  'use strict';

  var getal = function (n, std, min) {
    var x = parseInt(n, 10);
    if (!isFinite(x)) x = std;
    return Math.max(min == null ? 0 : min, x);
  };
  var tekst = function (v) { return v == null ? '' : String(v); };

  /* Geldt het schema nu? Zonder schema, of uitgezet: altijd. Een datum die
     niet te lezen is telt niet mee (liever een aanbod dat doorloopt dan een
     aanbod dat stil verdwijnt door een typefout). */
  function schemaGeldt(schedule, nu) {
    if (!schedule || !schedule.enabled) return true;
    var t = nu == null ? Date.now() : (nu instanceof Date ? nu.getTime() : Number(nu));
    if (schedule.start_at) { var s = Date.parse(schedule.start_at); if (isFinite(s) && s > t) return false; }
    if (schedule.end_at) { var e = Date.parse(schedule.end_at); if (isFinite(e) && e < t) return false; }
    return true;
  }

  /* Is deze regel een eigen cadeau-regel van dit aanbod? Uitsluitend aan de
     eigenschap, nooit aan het product: dat is het hele verschil tussen "ons
     cadeau" en "de klant koopt hetzelfde product zelf". */
  /* Draagt deze regel het merk van een cadeau, van welk aanbod dan ook? Zo ja,
     dan is hij van ons en niet van de klant. */
  function heeftCadeauMerk(item) {
    return !!(item && item.properties && tekst(item.properties._cg_gift) !== '');
  }
  function isEigen(item, offerId) {
    return !!(item && item.properties && tekst(item.properties._cg_gift) !== '' && tekst(item.properties._cg_gift) === tekst(offerId));
  }

  /* Telt een regel mee als qualifying? Zelfde product, en als het aanbod
     varianten noemt: een van die varianten. Een cadeau-regel telt nooit mee,
     ook niet als cadeau en qualifying hetzelfde product zijn. */
  function isQualifying(item, offer) {
    if (!item || !offer || !offer.qualifying) return false;
    if (item.properties && tekst(item.properties._cg_gift) !== '') return false;
    if (tekst(item.product_id) !== tekst(offer.qualifying.product_id)) return false;
    var vids = Array.isArray(offer.qualifying.variant_ids) ? offer.qualifying.variant_ids.map(tekst) : [];
    return vids.length === 0 || vids.indexOf(tekst(item.variant_id)) >= 0;
  }

  /* Hoeveel cadeau hoort er in de wagen voor dit aanbod? Voldoet de wagen
     (som qualifying ≥ min_qty) → gift.qty, of bij allow_multiple
     min(max_gifts, floor(aantal / min_qty)) × gift.qty; anders 0. Buiten het
     schema: 0. */
  function gewensteHoeveelheid(cart, offer, nu) {
    if (!offer || !offer.gift || !schemaGeldt(offer.schedule, nu)) return 0;
    var items = (cart && cart.items) || [];
    var aantal = 0;
    for (var i = 0; i < items.length; i++) if (isQualifying(items[i], offer)) aantal += getal(items[i].quantity, 0, 0);
    var minQty = getal(offer.qualifying && offer.qualifying.min_qty, 1, 1);
    var giftQty = getal(offer.gift.qty, 1, 1);
    if (aantal < minQty) return 0;
    var g = offer.gedrag || {};
    if (!g.allow_multiple) return giftQty;
    var maxGifts = getal(g.max_gifts, 1, 1);
    return Math.min(maxGifts, Math.floor(aantal / minQty)) * giftQty;
  }

  /* De mutaties die de wagen kloppend maken. Puur: geen DOM, geen fetch.
     cart: de Ajax Cart API-vorm (items met variant_id, product_id, quantity,
     key, properties). offers: de aanbiedingen uit de config. nu: tijdstip
     (ms of Date), voor het schema. Geeft [{soort:'add', variant_id, quantity,
     properties}, {soort:'change', key, quantity}]. Herhaald draaien op de
     uitkomst geeft een lege lijst. */
  function bereken(cart, offers, nu) {
    var mutaties = [];
    var items = (cart && cart.items) || [];
    (offers || []).forEach(function (offer) {
      if (!offer || !offer.id || !offer.gift) return;
      var g = offer.gedrag || {};
      var autoAdd = g.auto_add !== false, autoRemove = g.auto_remove !== false;
      var eigen = items.filter(function (it) { return isEigen(it, offer.id); });
      var eigenAantal = 0;
      eigen.forEach(function (it) { eigenAantal += getal(it.quantity, 0, 0); });
      /* ── De klant heeft het cadeauproduct zelf al in de wagen ────────────
         Senne (9 september): "Als ik eerst los een Pro-Gel toevoeg en daarna
         de 3-in-1, dan lukt het niet meer om de betaalde Pro-Gel te
         verwijderen; die wordt steeds automatisch toegevoegd."

         Wat er gebeurde: de korting van Shopify maakt de Pro-Gel die de klant
         zelf koos AL gratis, want die kijkt naar het product en niet naar onze
         regeleigenschap. Wij zagen geen regel met `_cg_gift`, dachten dat het
         cadeau ontbrak en legden er een tweede bij. Twee identieke tubes, de
         korting op één ervan, en de regel die wij "cadeau" noemden kostte
         17,99 terwijl die van de klant nul was. Wie dan de betaalde weghaalde,
         haalde ONZE regel weg, en die zetten we meteen terug.

         Daarom telt een regel van de klant mee voor de vraag "is het cadeau er
         al". Wij raken zo'n regel nooit aan: hij is van de klant, en iemand die
         bewust twee tubes wil moet er twee kunnen houden. Alleen onze eigen
         regels mogen omlaag. */
      var vanKlant = 0;
      items.forEach(function (it) {
        if (!it || heeftCadeauMerk(it)) return;
        if (tekst(it.variant_id) !== tekst(offer.gift.variant_id)) return;
        vanKlant += getal(it.quantity, 0, 0);
      });
      var huidig = eigenAantal;
      var gewenst = gewensteHoeveelheid(cart, offer, nu);
      /* De vlaggen: meer alleen bij auto_add, minder alleen bij auto_remove,
         en meer nooit als het cadeau niet leverbaar is (Shopify zou een 422
         geven; wij zetten dan niets klaar). */
      var doel = eigenAantal;
      var tekort = gewenst - (eigenAantal + vanKlant);
      if (tekort > 0 && autoAdd && offer.gift.available !== false) doel = eigenAantal + tekort;
      if (eigenAantal > gewenst && autoRemove) doel = gewenst;
      if (doel < 0) doel = 0;
      if (eigen.length === 0) {
        if (doel > 0 && offer.gift.variant_id) {
          var props = {}; props._cg_gift = tekst(offer.id);
          mutaties.push({ soort: 'add', variant_id: tekst(offer.gift.variant_id), quantity: doel, properties: props });
        }
        return;
      }
      /* Meerdere eigen regels worden één: de eerste krijgt het doel, de rest
         nul. Eerst omhoog, dan de rest weg: de wagen heeft nooit tijdelijk
         minder cadeau dan hij hoort te hebben. */
      var eerste = eigen[0];
      if (getal(eerste.quantity, 0, 0) !== doel) mutaties.push({ soort: 'change', key: eerste.key, quantity: doel });
      for (var i = 1; i < eigen.length; i++) {
        if (getal(eigen[i].quantity, 0, 0) !== 0) mutaties.push({ soort: 'change', key: eigen[i].key, quantity: 0 });
      }
    });
    return mutaties;
  }

  /* Een bedrag in centen in het geldformaat van de winkel (shop.money_format),
     voor het terugvalblok op de productpagina. */
  function geld(centen, format) {
    var f = format || '€{{amount_with_comma_separator}}';
    var n = getal(centen, 0, 0);
    var vast = function (dec, duizend, komma) {
      var s = (n / 100).toFixed(dec);
      var delen = s.split('.');
      delen[0] = delen[0].replace(/\B(?=(\d{3})+(?!\d))/g, duizend);
      return delen.length > 1 ? delen[0] + komma + delen[1] : delen[0];
    };
    return f.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, soort) {
      switch (soort) {
        case 'amount_no_decimals': return vast(0, ',', '.');
        case 'amount_with_comma_separator': return vast(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return vast(0, '.', ',');
        case 'amount_with_space_separator': return vast(2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return vast(0, ' ', ',');
        case 'amount_with_period_and_space_separator': return vast(2, ' ', '.');
        case 'amount_with_apostrophe_separator': return vast(2, "'", '.');
        default: return vast(2, ',', '.');
      }
    });
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { bereken, gewensteHoeveelheid, schemaGeldt, isEigen, isQualifying, geld };
  }
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  /* ── De browser ──────────────────────────────────────────────────────── */
  var el = document.getElementById('cg-gift-config');
  if (!el) return;
  var config;
  try { config = JSON.parse(el.textContent || '{}'); } catch (e) { console.warn('cg-gift: config onleesbaar', e); return; }
  var offers = Array.isArray(config.offers) ? config.offers : [];
  if (!offers.length) return;
  var routes = config.routes || {};
  var R = { cart: routes.cart || '/cart', add: routes.add || '/cart/add', change: routes.change || '/cart/change', update: routes.update || '/cart/update' };
  var esc = function (s) { return tekst(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  /* Eén run tegelijk. Komt er een wijziging binnen terwijl we bezig zijn, dan
     zetten we een vlag en draaien we daarna nog één keer: de laatste stand
     telt, niet elke tussenstand. eigenAanroep staat aan tijdens onze eigen
     fetches, zodat de fetch-wrapper (als die er is) ons niet opnieuw start. */
  var bezig = false, nogEens = false, eigenAanroep = false;

  var vraag = function (url, body) {
    eigenAanroep = true;
    var opties = body
      ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }
      : { headers: { Accept: 'application/json' } };
    return fetch(url, opties).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error(r.status + ' ' + t.slice(0, 200)); });
      return r.json();
    }).finally(function () { eigenAanroep = false; });
  };

  /* Dawn-familie: het pub/sub-systeem (pubsub.js of main.js zet subscribe,
     publish en PUB_SUB_EVENTS als globale bindingen; PUB_SUB_EVENTS is een
     const, dus niet op window — vandaar typeof). Is het er, dan is het thema
     zelf de baas over de wagen: wij publiceren na een eigen wijziging een
     cartUpdate en het thema tekent zijn lade en zijn wagenpagina opnieuw
     met zijn eigen code. Zelf innerHTML vervangen is precies wat het thema
     kapotmaakt: de lade verloor zijn luisteraars en de prullenbak had drie
     klikken nodig (Sculptiq, 7 september). */
  var pubsub = typeof subscribe === 'function' && typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate;

  /* Na een eigen wijziging zonder pub/sub: de wagensecties opnieuw ophalen
     en neerzetten waar het element bestaat. Met pub/sub alleen het
     winkelwagen-icoon, want dat tekent het thema niet altijd zelf. */
  var SECTIES = [
    { id: 'cart-drawer', doel: function () { return document.getElementById('CartDrawer') || document.getElementById('cart-drawer'); }, selector: '#CartDrawer' },
    { id: 'cart-icon-bubble', doel: function () { return document.getElementById('cart-icon-bubble'); } },
    { id: 'main-cart-items', doel: function () { return document.getElementById('main-cart-items'); } },
    { id: 'main-cart-footer', doel: function () { return document.getElementById('main-cart-footer'); } },
  ];
  var ververs = function () {
    var aanwezig = (pubsub ? SECTIES.filter(function (s) { return s.id === 'cart-icon-bubble'; }) : SECTIES).filter(function (s) { return !!s.doel(); });
    if (!aanwezig.length) return Promise.resolve();
    var url = R.cart + (R.cart.indexOf('?') >= 0 ? '&' : '?') + 'sections=' + aanwezig.map(function (s) { return s.id; }).join(',');
    eigenAanroep = true;
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (data) {
      aanwezig.forEach(function (s) {
        var html = data && data[s.id];
        var doel = s.doel();
        if (!html || !doel) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var bron = (s.selector && doc.querySelector(s.selector)) || doc.getElementById(s.id);
        doel.innerHTML = bron ? bron.innerHTML : doc.body.innerHTML;
      });
    }).catch(function (e) { console.warn('cg-gift: secties verversen mislukte', e); }).finally(function () { eigenAanroep = false; });
  };

  var draai = function () {
    if (bezig) { nogEens = true; return; }
    bezig = true; nogEens = false;
    var veranderd = false;
    var stap = vraag(R.cart + '.js').then(function (cart) {
      var mutaties = bereken(cart, offers, Date.now());
      /* Na elkaar, niet tegelijk: Shopify verwerkt wagenwijzigingen serieel
         en twee gelijktijdige changes op dezelfde wagen geven een 422. */
      return mutaties.reduce(function (p, m) {
        return p.then(function () {
          var aanroep = m.soort === 'add'
            ? vraag(R.add + '.js', { items: [{ id: m.variant_id, quantity: m.quantity, properties: m.properties }] })
            : vraag(R.change + '.js', { id: m.key, quantity: m.quantity });
          return aanroep.then(function () { veranderd = true; }).catch(function (e) { console.warn('cg-gift: ' + m.soort + ' mislukte, de checkout gaat gewoon door', e); });
        });
      }, Promise.resolve());
    }).catch(function (e) { console.warn('cg-gift: wagen lezen mislukte', e); });
    stap.then(function () {
      if (!veranderd) return;
      return ververs().then(function () {
        if (pubsub) {
          /* Het thema tekent zelf: cart-items en cart-drawer-items luisteren
             naar cartUpdate van een andere bron dan zijzelf en halen dan de
             verse lade of wagenpagina op. De verse wagen gaat mee voor wie
             hem leest. */
          return vraag(R.cart + '.js').catch(function () { return null; }).then(function (cart) {
            try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cg-gift', cartData: cart }); } catch (e) { console.warn('cg-gift: cartUpdate publiceren mislukte', e); }
          });
        }
        try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { source: 'cg-gift' } })); } catch (e) { /* oude browser */ }
      });
    }).finally(function () {
      bezig = false;
      if (nogEens) draai();
    });
  };

  /* Wanneer de engine kijkt. Met pub/sub: na elke cartUpdate van het thema,
     met een korte adempauze zodat het thema eerst zijn eigen hertekening
     afmaakt (zijn publish komt aan het eind van zijn eigen verwerking, maar
     de lade opent soms nog). Anders de gangbare wagen-events; en alleen als
     er geen pub/sub is een dunne wrapper om fetch, die zich terugtrekt zodra
     het thema zelf events blijkt te sturen. */
  var isEigenEvent = function (ev) { return !!(ev && ev.detail && ev.detail.source === 'cg-gift'); };
  var wacht = null;
  var draaiStraks = function () { clearTimeout(wacht); wacht = setTimeout(draai, 120); };
  if (pubsub) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) { if (ev && ev.source === 'cg-gift') return; draaiStraks(); });
  } else {
    var themaStuurtEvents = false;
    ['cart:refresh', 'cart:updated', 'cart:change', 'product:added'].forEach(function (naam) {
      document.addEventListener(naam, function (ev) { if (isEigenEvent(ev)) return; themaStuurtEvents = true; draaiStraks(); });
    });
    if (typeof window.fetch === 'function') {
      var origineel = window.fetch;
      var wagenPad = new RegExp('(^|/)cart/(add|change|update|clear)(\\.js|\\b)');
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = origineel.apply(this, arguments);
        if (!eigenAanroep && !themaStuurtEvents && wagenPad.test(url)) {
          p.then(function () { draaiStraks(); }, function () { /* een mislukte aanroep van het thema is niet van ons */ });
        }
        return p;
      };
    }
  }

  /* Het aanbodblok op de productpagina als de installer geen veilige plek
     vond: vóór het koopformulier, alleen als het er nog niet staat, en alleen
     voor een aanbod dat nu geldt en leverbaar is. Het product-id komt van
     Shopify's eigen meta-object. */
  (function () {
    if (document.querySelector('.cg-gift')) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    var meta = window.meta && window.meta.product;
    if (!form || !meta || !meta.id) return;
    var pid = tekst(meta.id);
    var offer = null;
    for (var i = 0; i < offers.length; i++) {
      var o = offers[i];
      if (o && o.qualifying && tekst(o.qualifying.product_id) === pid && o.display && o.display.enabled !== false && o.gift && o.gift.available !== false && o.gift.variant_id && schemaGeldt(o.schedule, Date.now())) { offer = o; break; }
    }
    if (!offer) return;
    var d = offer.display || {};
    var titel = d.custom_title || offer.gift.title || '';
    var kleur = /^#[0-9a-f]{3}([0-9a-f]{3})?$/i.test(tekst(d.badge_color)) ? d.badge_color : '';
    var html = '<div class="cg-gift" data-cg-gift="' + esc(offer.id) + '" data-cg-gift-variant="' + esc(offer.gift.variant_id) + '"' + (kleur ? ' style="--cg-gift-accent:' + esc(kleur) + '"' : '') + '>'
      + '<div class="cg-gift__image">' + (offer.gift.image ? '<img src="' + esc(offer.gift.image) + '" loading="lazy" alt="' + esc(offer.gift.title || '') + '">' : '') + '</div>'
      + '<div class="cg-gift__content">'
      + (d.badge_text ? '<div class="cg-gift__badge">' + esc(d.badge_text) + '</div>' : '')
      + '<div class="cg-gift__row"><strong>' + esc(titel) + '</strong><div class="cg-gift__price">'
      + (d.show_original_price !== false ? '<s>' + esc(geld(offer.gift.price, config.money_format)) + '</s>' : '')
      + '<b>' + esc(d.free_label || 'GRATIS') + '</b></div></div>'
      + (d.subtext ? '<div class="cg-gift__sub">' + esc(d.subtext) + '</div>' : '')
      + '</div></div>';
    form.insertAdjacentHTML('beforebegin', html);
  })();

  /* Bij het laden: de wagen kan al vol zijn (terug van de checkout, een
     verlopen schema, een aanbod dat net gepubliceerd is). */
  draai();
})();
